import { useEffect, useState } from 'react'
import { SectionTitle } from '../sectionTitle'
import GImage from '../gImage'
import * as S from './styles'

const ImagemPadrao = `${process.env.INTERNAL_IMAGES_URL}/images/jpg/produto-default.jpg`

export default function SetorPromocao({
  titulo = 'Promoções Imperdíveis',
  subtitulo = 'Confira mais promoções',
  banners,
  darkTheme,
}) {
  const [innerWidth, setInnerWidth] = useState(0)

  useEffect(() => {
    setInnerWidth(window.innerWidth)
  }, [])

  const getBannerImage = (banner) => {
    const imageUrl =
      innerWidth < 480
        ? banner?.banner?.imagem_mobile?.url
        : banner?.banner?.imagem_desktop?.url

    return imageUrl ?? ImagemPadrao
  }

  function registrarClick(e) {
    e.preventDefault()

    const targetDOM = e.currentTarget
    const id_banner = targetDOM.dataset.id

    fetch(
      `${process.env.REACT_APP_API_URI}/canais/banners/${id_banner}/clicks`,
      {
        method: 'PATCH',
        headers: {
          canal: 'gazin-ecommerce',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
        },
      }
    ).then(() => {
      if (targetDOM.target == '_self')
        return (window.location.href = targetDOM.href)
      return window.open(targetDOM.href, targetDOM.target)
    })
  }

  return (
    <S.PromotionBoxesSection darkTheme={darkTheme}>
      <S.PromotionContainer>
        <SectionTitle
          title={titulo}
          subtitle={subtitulo}
          darkTheme={darkTheme}
        />

        <S.PromotionBoxGrid>
          {banners?.data &&
            banners.data.map((banner, key) => (
              <S.PromotionBox key={key}>
                <a
                  href={banner.banner.link.parametros.url}
                  target={banner.banner.link.parametros.target}
                  data-id={banner.banner.id}
                  onClick={(event) => registrarClick(event)}
                >
                  <GImage
                    src={getBannerImage(banner)}
                    alt={banner.banner.titulo}
                    fill
                    sizes="19.2188rem"
                  />
                </a>
              </S.PromotionBox>
            ))}
        </S.PromotionBoxGrid>
      </S.PromotionContainer>
    </S.PromotionBoxesSection>
  )
}
